import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ProductSizeTable } from '../../../models/product';
import { ProductSizeTableDialog } from '../product-size-table-dialog/product-size-table-dialog';

@Component({
  selector: 'app-product-size-table-button',
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './product-size-table-button.html',
  styleUrl: './product-size-table-button.scss',
})
export class ProductSizeTableButton {
  @Input({ required: true }) data!: ProductSizeTable;
  constructor(private dialog: MatDialog) {}

  open() {
    this.dialog.open(ProductSizeTableDialog, {
      width: '640px',
      data: this.data,
    });
  }
}
